import React from 'react';
import { motion } from 'framer-motion';
import FormInput from './FormInput';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMapPin, FiInfo, FiExternalLink } = FiIcons;

const StepTwo = ({ formData, updateFormData, errors }) => {
  const exampleUrls = [
    "https://maps.google.com/maps?q=Mumbai+Central+Station",
    "https://goo.gl/maps/ABC123def456",
    "https://maps.app.goo.gl/XYZ789abc123"
  ];

  return (
    <motion.div
      initial={{ opacity: 0, x: 50 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -50 }}
      transition={{ duration: 0.4 }}
      className="w-full"
    >
      <div className="text-center mb-8">
        <motion.div
          animate={{ scale: [1, 1.1, 1] }}
          transition={{ duration: 2, repeat: Infinity }}
          className="text-6xl mb-4"
        >
          📍
        </motion.div>
        <h2 className="text-2xl font-bold text-brand-primary mb-2">
          Where Should We Deliver?
        </h2>
        <p className="text-brand-primary/70 text-lg">
          Share your Google Maps location for accurate delivery
        </p>
      </div>

      <FormInput
        label="Google Maps Location URL"
        icon={FiMapPin}
        value={formData.mapUrl}
        onChange={(e) => updateFormData('mapUrl', e.target.value)}
        placeholder="Paste your Google Maps link here..."
        error={errors.mapUrl}
        success={formData.mapUrl && !errors.mapUrl}
        required
      />

      <div className="bg-brand-cream p-6 rounded-2xl mb-6">
        <div className="flex items-start space-x-3 mb-4">
          <SafeIcon icon={FiInfo} className="text-brand-orange text-xl mt-1 flex-shrink-0" />
          <div>
            <p className="text-brand-primary font-semibold mb-2">How to get your Google Maps URL:</p>
          </div>
        </div>

        <div className="space-y-4">
          <div className="bg-brand-white p-4 rounded-xl">
            <p className="text-brand-primary font-semibold mb-2">📱 On Mobile:</p>
            <ol className="list-decimal list-inside text-brand-primary/80 text-sm space-y-1">
              <li>Open Google Maps app</li>
              <li>Search for your location</li>
              <li>Tap on the location pin</li>
              <li>Tap "Share" button</li>
              <li>Copy the link and paste it above</li>
            </ol>
          </div>

          <div className="bg-brand-white p-4 rounded-xl">
            <p className="text-brand-primary font-semibold mb-2">💻 On Computer:</p>
            <ol className="list-decimal list-inside text-brand-primary/80 text-sm space-y-1">
              <li>Go to maps.google.com</li>
              <li>Search for your location</li>
              <li>Click "Share" button</li>
              <li>Copy the link and paste it above</li>
            </ol>
          </div>
        </div>
      </div>

      <div className="bg-gradient-to-r from-brand-orange/10 to-brand-primary/10 p-6 rounded-2xl">
        <div className="flex items-start space-x-3 mb-4">
          <SafeIcon icon={FiExternalLink} className="text-brand-primary text-xl mt-1 flex-shrink-0" />
          <div>
            <p className="text-brand-primary font-semibold mb-2">Example URL formats:</p>
          </div>
        </div>
        
        <div className="space-y-3">
          {exampleUrls.map((url, index) => (
            <div
              key={index}
              className="bg-brand-white p-3 rounded-xl border border-brand-gray"
            >
              <p className="text-brand-primary/80 text-sm font-mono break-all">
                {url}
              </p>
            </div>
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default StepTwo;